import { createFeatureSelector, createSelector } from '@ngrx/store'
import { State } from './state'
import * as reducer from './reducer'
import { DataEntityType } from '@tokeet-frontend/tv3-platform'

export const attributeState = createFeatureSelector<State>('attrs')

export const selectEntityAttributesLoaded = createSelector(attributeState, (state: State) => state.isLoaded)

export const selectEntityAttributesSaving = createSelector(attributeState, (state: State) => state.isSaving)

export const selectEntityAttributeEntities = createSelector(attributeState, reducer.selectEntities)

export const selectAllEntityAttributes = createSelector(attributeState, reducer.selectAll)

export const selectEntityAttributesByType = (entityType: DataEntityType) =>
  createSelector(selectAllEntityAttributes, (items) => {
    return items.filter((item) => item.entity_type === entityType)
  })

export const selectEntityAttributesByEntityId = (id: string) =>
  createSelector(selectAllEntityAttributes, (items) => {
    return items?.find((t) => t.entity_pkey === id)
  })
